import loadable from '@loadable/component';
import './TripConnection.css';

export default loadable(() => {
  return import('./TripConnection.jsx');
});
